import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import ImportResrource from '../../byMemberResource/import/import';
import EditResource from '../edit/index';
export default {
  components: {
    ImportResrource: ImportResrource,
    EditResource: EditResource
  },
  name: 'ByMemberResourceDownList',
  data: function data() {
    return {
      citys: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      downloadUrl: process.env.VUE_APP_DOWNLOAD_URL,
      byMemberResourceSexEnums: [],
      byMemberResourceCityEnums: [],
      isSelect: this.checkauthority('member_resource_select'),
      isCreate: this.checkauthority('member_resource_create'),
      isUpdate: this.checkauthority('member_resource_update'),
      isDelete: this.checkauthority('member_resource_delete'),
      selectForm: {
        memberId: null,
        sex: '',
        city: '',
        pushTime: [],
        selectCitys: [],
        membership: null,
        noOrPhone: null
      },
      sex: [],
      editDisabled: false,
      dialogVisible: false,
      addEditDisabled: false,
      addDialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false
    };
  },
  methods: {
    importExcel: function importExcel() {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('导入资源');
      this.$refs.edit.setData({});
    },
    exportExcel: function exportExcel() {
      var par = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        memberId: this.selectForm.memberId,
        sex: this.selectForm.sex,
        city: this.selectForm.city,
        membership: this.selectForm.membership,
        noOrPhone: this.selectForm.noOrPhone,
        pushSts: 0
      };
      if (this.selectForm.pushTime.length >= 2) {
        par.pushStartTime = this.selectForm.pushTime[0];
        par.pushEndTime = this.selectForm.pushTime[1];
      }
      if (this.selectForm.selectCitys.length > 0) {
        par.province = this.selectForm.selectCitys[0];
        par.city = this.selectForm.selectCitys[1];
        if (this.selectForm.selectCitys.length > 2) {
          par.area = this.selectForm.selectCitys[2];
        }
      }
      var apiUrl = 'admin/v1/byMemberResource/exportPageList';
      this.downloadUtil.excelExport(apiUrl, par, '资源推送统计表.xls');
    },
    getSexEnumList: function getSexEnumList(name) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                name: name
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              _this.sex = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    initCitys: function initCitys() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return api.GET_BYCITYOPENING_SELECT_TREE_LIST({});
            case 1:
              res = _context2.v;
              _this2.citys = res.body;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    getImagesImage: function getImagesImage(row) {
      try {
        var url = JSON.parse(row.images)[0].url;
        return url;
      } catch (e) {
        return '';
      }
    },
    getImagesImages: function getImagesImages(row) {
      try {
        var images = JSON.parse(row.images);
        var urls = [];
        images.forEach(function (img) {
          urls.push(img.url);
        });
        return urls;
      } catch (e) {
        return '';
      }
    },
    membership: function membership(row) {
      if (row.member !== null) {
        if (row.member.membership === 1) {
          return '单身';
        } else if (row.member.membership === 2) {
          return '家长';
        } else if (row.member.membership === 3) {
          return '红娘';
        }
      }
    },
    membershipNickName: function membershipNickName(row) {
      if (row.member !== null) {
        if (row.member.membership === 1) {
          return row.member.nickName;
        } else if (row.member.membership === 2) {
          return row.member.nickName + row.member.callstr;
        } else if (row.member.membership === 3) {
          return row.member.nickName;
        }
      }
    },
    initEunmData: function initEunmData() {
      this.getEnumList('key');
    },
    getEnumList: function getEnumList(name) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par, res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                name: name
              };
              _context3.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context3.v;
              _this3.enumList = res.body;
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this4 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.daleteApi(index, data);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var par;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              par = {
                resourceId: data.resourceId
              };
              _context4.n = 1;
              return api.DELETE_BYMEMBERRESOURCE(par);
            case 1:
              _this5.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return api.DELETE_BATCH_BYMEMBERRESOURCE(par);
            case 1:
              _this6.$message.success('操作成功');
              _this6.initTableData();
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this7 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this7.tableSelects.forEach(function (element) {
          par.push(element.resourceId);
        });
        _this7.deleteBatchApi(par);
      }).catch(function () {
        _this7.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setTitle('详情');
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setTitle('编辑');
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.$refs.editResource.setTitle('推送资源');
      this.addEditDisabled = false;
      this.addDialogVisible = true;
      this.$refs.editResource.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    addUserEditClose: function addUserEditClose() {
      this.addDialogVisible = false;
    },
    reset: function reset() {
      this.pageNo = 1;
      this.selectForm.memberId = null;
      this.selectForm.sex = '';
      this.selectForm.city = '';
      this.selectForm.pushTime = [];
      this.selectForm.selectCitys = [];
      this.selectForm.membership = null;
      this.selectForm.noOrPhone = null;
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var par, res;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              par = {
                pageNo: _this8.pageNo,
                pageSize: _this8.pageSize,
                memberId: _this8.selectForm.memberId,
                sex: _this8.selectForm.sex,
                city: _this8.selectForm.city,
                membership: _this8.selectForm.membership,
                noOrPhone: _this8.selectForm.noOrPhone,
                pushSts: 0
              };
              if (_this8.selectForm.pushTime.length >= 2) {
                par.pushStartTime = _this8.selectForm.pushTime[0];
                par.pushEndTime = _this8.selectForm.pushTime[1];
              }
              if (_this8.selectForm.selectCitys.length > 0) {
                par.province = _this8.selectForm.selectCitys[0];
                par.city = _this8.selectForm.selectCitys[1];
                if (_this8.selectForm.selectCitys.length > 2) {
                  par.area = _this8.selectForm.selectCitys[2];
                }
              }
              _context6.n = 1;
              return api.GET_BYMEMBERRESOURCE_PAGE_LIST(par);
            case 1:
              res = _context6.v;
              _this8.tableData = res.body.datas;
              _this8.pageTotal = res.body.sumDataCount;
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initCitys();
    this.getSexEnumList('member_sex');
    this.initTableData();
  }
};